import React from "react";
import style from "./footer.module.css";
import DownloadApp from "../DownloadApp/DownloadApp";
import { useAppSelector } from "../../store/hooks";
import { GameStep } from "../../types/config";
interface footerPrp {
  className?: string;
}
const FooterCo: React.FC<footerPrp> = ({ className }) => {
  const gameStep = useAppSelector((state) => state.config.gameSteps);
  return (
    <div className={` ${style.footer} ${className}`}>
      <div className={style["footer-inner"]}>
        {gameStep === GameStep.HOME && <DownloadApp />}
        <a href="https://www.banimode.com/" target="_blank" rel="noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/banilogo.svg`}
            alt="banilogo"
            className={`${style.logo} mobile`}
          />
        </a>
        <span className={style.text}>© Copyright 2024 Banimode.com</span>
      </div>
    </div>
  );
};

export default FooterCo;
